<greco-subscription-schedule-section
  [canCancel]="false"
  [subscription]="data.subscription"
  [communityId]="data.communityId"
  [disabled]="true"
  [canMakeChange]="true"
></greco-subscription-schedule-section>
